<template>
    <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
</template>

<script>

export default {
  name: 'SystemPerformanceChart',
  props: {
    chartData: {
      default: () => [],
      type: Array
    }
  },
  data () {
    return {
      series: [
        {
          name: 'Generation (kWh)',
          type: 'column',
          data: []
        },
        {
          name: 'Consumption (kWh)',
          type: 'area',
          data: []
        }
      ],
      chartOptions: {
        chart: {
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          },
          height: 350,
          type: 'line',
          stacked: false
        },
        stroke: {
          width: [0, 2, 5],
          curve: 'smooth'
        },
        plotOptions: {
          bar: {
            columnWidth: '50%'
          }
        },
        colors: ['#0176ff', '#0176ff38'],
        fill: {
          opacity: [0.85, 0.25, 1],
          gradient: {
            inverseColors: false,
            shade: 'light',
            type: 'vertical',
            opacityFrom: 0.85,
            opacityTo: 0.55,
            stops: [0, 100, 100, 100]
          }
        },
        title: {
          text: 'System Performance',
          align: 'center',
          style: {
            fontFamily: "'Open Sans', Arial, Helvetica, sans- serif"
          }
        },
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        markers: {
          size: 0
        },
        yaxis: {
          title: {
            text: ''
          },
          labels: {
            style: {
              fontFamily: "'Open Sans', Arial, Helvetica, sans- serif"
            },
            formatter: (value) => Math.floor(value)
          }
        },
        tooltip: {
          enabled: false
        },
        legend: {
          onItemClick: {
            toggleDataSeries: false
          },
          onItemHover: {
            highlightDataSeries: false
          }
        }
      }
    };
  },
  mounted () {
    this.series[0].data = this.chartData.map(item => item.solarGeneration);
    this.series[1].data = this.chartData.map(item => item.householdConsumption);
  }
};
</script>
